import { render, staticRenderFns } from "./groupBy.template?vue&type=template&id=7cc11aa1&lang=pug&"
import script from "./groupBy.client?vue&type=script&lang=ts&"
export * from "./groupBy.client?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/flypaper/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cc11aa1')) {
      api.createRecord('7cc11aa1', component.options)
    } else {
      api.reload('7cc11aa1', component.options)
    }
    module.hot.accept("./groupBy.template?vue&type=template&id=7cc11aa1&lang=pug&", function () {
      api.rerender('7cc11aa1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/widgets/groupBy/groupBy.component.vue"
export default component.exports